import Config from '@config';
import variables from '@styles/variables';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
import Heading from '@atoms/Heading/Heading';
import Modal from '@organisms/Modal/Modal';
import { MODAL_NAV_HEIGHT } from '@organisms/Modal/Modal.styles';

// Responsive padding mixin
const ResponsivePadding = css`
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  }
`;

export const StyledCartConflictModal = styled(Modal)`
  // Override the max-height of the Modal (which uses larger padding)
  // to fit the content on larger screens, mobile is already full height.
  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    max-height: calc(100vh - ${rem(16)});
  }
`;

export const StyledCartConflict = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  // Decrease the space between the modal top to display more content
  // Applied to the whole content of the modal
  margin-top: -${MODAL_NAV_HEIGHT};

  // Max height allows content to be resized
  max-height: 100dvh;

  // Margin needs to be taken into account on larger screens.
  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    max-height: calc(100vh - ${MODAL_NAV_HEIGHT});
  }
`;

export const StyledHeaderWrapper = styled.div`
  // Compensate for the negative margin on the top level element.
  // pushing down the header and following elements.
  padding-top: ${rem(20)};

  ${ResponsivePadding}
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: ${rem(10)};
  border-bottom: ${rem(1)} dashed ${variables.colors.mediumGray};
`;

export const StyledScrollableContent = styled.div`
  // Keep shadows full width but add padding to the content.
  ${ResponsivePadding}
`;

export const StyledHeading = styled(Heading)`
  align-self: flex-start;
`;

export const StyledHeaderNoReplacement = styled.div`
  margin: ${rem(20)} 0;
`;

export const StyledReplaceText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: ${rem(1)} dashed ${variables.colors.mediumGray};
  padding-top: ${rem(20)};
`;

export const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: ${rem(20)};
  padding: ${rem(20)} 0;

  ${ResponsivePadding}
`;
